import {AbstractControl, FormArray, FormControl, FormGroup} from "@angular/forms";

export default function  markAllControlsAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);

        if (control instanceof FormControl) {
            // Mark the control as touched and reset its value
            if (control.untouched && !control.value) {
                control.markAsTouched();
                control.setValue(''); // Reset to default value (can be adjusted)
            }
        } else if (control instanceof FormGroup) {
            // Recursively handle nested FormGroups
            markAllControlsAsTouched(control);
        } else if (control instanceof FormArray) {
            // Handle FormArray elements
            control.controls.forEach((nestedControl: AbstractControl) => {
                if (nestedControl instanceof FormGroup) {
                    markAllControlsAsTouched(nestedControl);
                } else if (nestedControl instanceof FormControl) {
                    if (nestedControl.untouched && !nestedControl.value) {
                        nestedControl.markAsTouched();
                        nestedControl.setValue(''); // Reset to default value
                    }
                }
            });
        }
    });
}